module.exports = __webpack_public_path__ + "static/media/nepza-logo.a471476e.jpg";